import Paper from '@mui/material/Paper'
import IconButton from '@mui/material/IconButton'
import ZoomOutIcon from '@mui/icons-material/Remove'
import Tooltip from '@mui/material/Tooltip'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'

const useStyles = makeStyles((theme: Theme) => ({
    iconColor: {
        width: '24px',
        height: '24px',
        '&:hover path': {
            fill: '#318AF1',
        },
        '&:hover circle': {
            fill: '#318AF1',
        },
    },
}))

type MapToolZoomOutProps = {
    onClickZoomOut?: () => void
}
const MapToolZoomOut = (props: MapToolZoomOutProps) => {
    const { t } = useTranslation()
    const classes = useStyles()

    const onClickZoomOut = () => () => {
        props.onClickZoomOut?.()
    }

    return (
        <Paper sx={{ mb: '8px' }}>
            <Tooltip title={t('LABEL.MAP.TOOLS.ZOOM_OUT') ?? ''} placement="left">
                <IconButton
                    sx={{ p: '10px', bgcolor: '#fff', borderRadius: '5px', width: '100%' }}
                    aria-label="directions"
                    onClick={onClickZoomOut()}
                >
                    <ZoomOutIcon className={classes.iconColor} />
                </IconButton>
            </Tooltip>
        </Paper>
    )
}

export default MapToolZoomOut
